module.exports = __webpack_public_path__ + "img/i2.1daf25d3.png";